import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/introslides')({
  beforeLoad: () => {
    throw redirect({ to: '/' })
  },
})
